import Typography from "@/ui/atoms/Typography"
import { FieldDefinition } from "../../types"

export interface CustomFormFieldLabelProps {
  definition: FieldDefinition
  className?: string
}

const CustomFormFieldLabel = ({
  definition,
  className,
}: CustomFormFieldLabelProps) => {
  return (
    <Typography
      variant={"body3"}
      textTransform={"uppercase"}
      weight={"light"}
      inheritColor
      className={className}
    >
      {definition.label}
    </Typography>
  )
}

export default CustomFormFieldLabel
